// extracted by mini-css-extract-plugin
export default {"gridRow":"ApplicationRoleItem_gridRow__v9Wnm","application":"ApplicationRoleItem_application__18M+c","appImage":"ApplicationRoleItem_appImage__o4dd6"};